import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import LeaveFilter from "./LeaveFilter";
import axios from "axios";

import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, LabelList } from 'recharts';


export const EmployeeLeave = () => {
  const [fieldInputs, setFieldInputs] = useState(true);
  const [billMonth, setBillMonth] = useState(["6"]);
  const [consumer, setConsumer] = useState(["DS"]);
  const [billStatus, setBillStatus] = useState(["ALL"]);
  const [graphData, setGraphData] = useState([]);

  const getData = async () => {
    const graph_url = "https://tripura.saielectricity.com/payment_predection/Handler/payment_pred_handler.php";

    const graph_data = {
      "BillMonth": billMonth,
      "CONSUMER_CATEGORY": consumer,
    };

    try {
      const response = await axios.post(graph_url, graph_data);

      setGraphData(response.data.data);
    } catch (error) {
      setGraphData([]);
      console.log('error in data posting to get graph data');
    }
  };

  useEffect(() => {
    getData();
  }, [billMonth, consumer]);

  const transformedData = graphData.reduce((acc, item) => {
    const { bill_month, consumer_category, probability_bucket, payment_done, consumer_count, payment_percentage } = item;

    // Initialize the month in the accumulator if it doesn't exist
    if (!acc[bill_month]) acc[bill_month] = {};

    // Initialize the consumer category within the month if it doesn't exist
    if (!acc[bill_month][consumer_category]) {
      acc[bill_month][consumer_category] = {
        '0-30': { paid: 0, unpaid: 0, paid_percentage: 0, unpaid_percentage: 0 },
        '31-70': { paid: 0, unpaid: 0, paid_percentage: 0, unpaid_percentage: 0 },
        '71-100': { paid: 0, unpaid: 0, paid_percentage: 0, unpaid_percentage: 0 },
      };
    }

    // Update the paid or unpaid count and percentage based on payment_done status
    const bucket = acc[bill_month][consumer_category][probability_bucket];

    if (payment_done === 1) {
      bucket.paid += consumer_count; // Sum paid counts
      bucket.paid_percentage = parseFloat(payment_percentage); // Set paid percentage
    } else {
      bucket.unpaid += consumer_count; // Sum unpaid counts
      bucket.unpaid_percentage = parseFloat(payment_percentage); // Set unpaid percentage
    }

    return acc;
  }, {});


  console.log("transformDatatransformData", transformedData)

  // Function to render charts
  // Inside renderCharts function
  const renderCharts = () => {
    return Object.keys(transformedData).map((billMonth) => (
      Object.keys(transformedData[billMonth]).map((consumerCategory, index) => {
        const bucketData = transformedData[billMonth][consumerCategory];

        // Create data for Recharts with percentages
        const chartData = [
          { name: "0-30", paid: bucketData['0-30'].paid, unpaid: bucketData['0-30'].unpaid, paid_percentage: bucketData['0-30'].paid_percentage, unpaid_percentage: bucketData['0-30'].unpaid_percentage },
          { name: "31-70", paid: bucketData['31-70'].paid, unpaid: bucketData['31-70'].unpaid, paid_percentage: bucketData['31-70'].paid_percentage, unpaid_percentage: bucketData['31-70'].unpaid_percentage },
          { name: "71-100", paid: bucketData['71-100'].paid, unpaid: bucketData['71-100'].unpaid, paid_percentage: bucketData['71-100'].paid_percentage, unpaid_percentage: bucketData['71-100'].unpaid_percentage },
        ];

        return (
          <div key={`${billMonth}-${consumerCategory}`} style={{ marginBottom: "20px", position: 'relative' }}>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart
                data={chartData}
                layout="vertical"
                margin={{ top: 10, right: 20, left: 10, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  type="number"
                  hide={index < Object.keys(transformedData[billMonth]).length - 1}
                />
                <YAxis
                  type="category"
                  dataKey="name"
                  offset={50}
                  label={{
                    value: consumerCategory,
                    angle: -90,
                    position: 'insideLeft',
                    fontSize: 16,
                    fontWeight: 'bold'
                  }}
                />
                <Tooltip />
                <Bar dataKey="paid" name="Paid" stackId="a" fill="#82ca9d">
                  <LabelList
                    dataKey="paid_percentage"
                    position="center"
                    formatter={(value) => `${parseFloat(value).toFixed(2)}%`}
                    style={{
                      padding: 4, // Adjusts spacing around the label
                    }}
                  />
                </Bar>
                <Bar dataKey="unpaid" name="Unpaid" stackId="a" fill="#EA580C">
                  <LabelList
                    dataKey="unpaid_percentage"
                    position="center"
                    formatter={(value) => `${parseFloat(value).toFixed(2)}%`}
                    style={{
                      padding: 4, // Adjusts spacing around the label
                    }}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>

            {/* Custom vertical line */}
            <div style={{
              position: 'absolute',
              left: '50px',
              top: '10%',
              height: '90%',
              borderLeft: '2px dashed black',
            }} />
          </div>
        );
      })
    ));
  };

  return (
    <>
      <ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row align-items-center">
            <div className="col">
              <h3 className="page-title">{"Payment Prediction Accuracy"}</h3>
              <br />
            </div>

            <div
              className="filter-filelds"
              id="filter_inputs"
              style={{ display: fieldInputs ? "block" : "none" }}
            >
              <LeaveFilter
                setBillMonth={setBillMonth}
                setConsumer={setConsumer}
                setBillStatus={setBillStatus}
              />
            </div>

            <hr />
            <br />
            <br />
            <br />
          </div>
          <div className="card">
            <div className="card-body" style={{ width: '80%', margin: '0 auto', padding: '10px' }}>
              {renderCharts()}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default EmployeeLeave;
